import { ClientState } from '@features/client-state/client-state';
import { dig } from '@imcc/utilities';
import { CollectionAction } from '../collection-action.interface';
import { CollectionState } from '../collection-state.interface';

const onStateSuccess = (
  state: CollectionState,
  action: CollectionAction,
): CollectionState => {
  const { clientCollection }: ClientState = dig(
    action,
    'clientStateRequestDTO',
  );

  if (!clientCollection) {
    return state;
  }

  return {
    ...state,
    defaultCollectionId: clientCollection.activeCollectionId,
  };
};

export default onStateSuccess;
